var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"6884f7e77085fc556c63eff1d8741e76b18ee48e"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["goals-wizard@success-wizard"]={id:"6884f7e77085fc556c63eff1d8741e76b18ee48e"};
      